var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadFileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#6e8192",
    viewBox: "0 0 32 32",
    id: "download",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 .5A1.5 1.5 0 0 0 14.5 2v16.09l-3.515-3.514c-1.413-1.37-3.494.703-2.12 2.121l6.074 6.075c.568.589 1.554.57 2.122 0l6.075-6.075c1.368-1.416-.702-3.492-2.121-2.12L17.5 18.09V2A1.5 1.5 0 0 0 16 .5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.85 20.212a1.5 1.5 0 0 0-1.5 1.5v2.213c0 4.177 3.398 7.575 7.575 7.575h12.15c4.177 0 7.575-3.398 7.575-7.575v-2.213a1.5 1.5 0 0 0-3 0v2.213a4.58 4.58 0 0 1-4.575 4.575H9.925a4.58 4.58 0 0 1-4.575-4.575v-2.213a1.5 1.5 0 0 0-1.5-1.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadFileIcon);
export default __webpack_public_path__ + "static/media/download-file-icon.2394621b74cc435260cf2b0844bbde36.svg";
export { ForwardRef as ReactComponent };